import { allCountryData } from '@/constants';

export const getCountriesByContinent = (continent: string) => allCountryData.filter((country) => country.continent === continent);

export const getCountryByCode = (code: string) => allCountryData.find((item) => item.code === code);
